import React, { useEffect, useState } from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import MenuIcon from "@mui/icons-material/Menu";
import { CssBaseline, IconButton } from "@mui/material";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItemReservation from "./ListItemReservation";
import ListItemSams from "./ListItemSams";
import ListItemSq from "./ListItemSq";
import LISTITEMDPR from "./LISTITEMDPR";
import ListItemIt from "./ListItemIt";

const drawerWidth = 220;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),

  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function ButtonAppBar() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [displayText, setDisplayText] = useState("");
  const history = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleLogout = () => {
    history("/");
    sessionStorage.clear();
  };
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    if (windowWidth < 768) {
      setDisplayText("AACT");
    } else {
      setDisplayText("AACT");
    }
  }, [windowWidth]);
  const typographyStyle = {
    ml: windowWidth < 768 ? "1px" : "40px",
  };
  const arrowClick = () => {
    history("/reservation");
  };
  const samsgo = () => {
    history("/sams/dashboard");
  };
  const sq = () => {
    history("/sq/holdlist");
  };
  const edi = () => {
    history("/edi/livelist");
  };
  const reservationgo = () => {
    history("/reservation");
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar position="fixed" open={open}>
        <Toolbar
          sx={{ justifyContent: "space-between", backgroundColor: "#0C4876" }}
        >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{
              marginRight: 1,
              ...(open && { display: "none" }),
            }}
          >
            <MenuIcon />
          </IconButton>
          {location.pathname === "/reservation/insert" && (
            <ArrowBackIosIcon
              onClick={(e) => {
                e.stopPropagation();
                arrowClick();
              }}
            />
          )}
          <Typography variant="h7" component="div" sx={typographyStyle}>
            {displayText}
          </Typography>
          {sessionStorage.getItem("sams") === "Y" ? (
            <Button
              onClick={(e) => {
                samsgo();
                e.stopPropagation();
              }}
              variant="text"
              sx={{
                color: "white",
                marginLeft: 10,
                display: windowWidth < 768 ? "none" : "inline-flex",
              }}
            >
              CARGO VOLUME
            </Button>
          ) : (
            ""
          )}

          {sessionStorage.getItem("sq") === "Y" ? (
            <Button
              onClick={(e) => {
                sq();
                e.stopPropagation();
              }}
              variant="text"
              sx={{
                color: "white",
                marginLeft: 5,
                display: windowWidth < 768 ? "none" : "inline-flex",
              }}
            >
              {sessionStorage.getItem("carrierCode")}
            </Button>
          ) : (
            ""
          )}

          {sessionStorage.getItem("sq") === "Y" ||
          sessionStorage.getItem("sams") === "Y" ? (
            sessionStorage.getItem("it") === "Y" ? (
              <Button
                onClick={(e) => {
                  reservationgo();
                  e.stopPropagation();
                }}
                variant="text"
                sx={{
                  color: "white",
                  marginLeft: 5,
                  display: windowWidth < 768 ? "none" : "inline-flex",
                }}
              >
                MEETING
              </Button>
            ) : (
              ""
            )
          ) : (
            <Button
              onClick={(e) => {
                reservationgo();
                e.stopPropagation();
              }}
              variant="text"
              sx={{
                color: "white",
                marginLeft: 5,
                display: windowWidth < 768 ? "none" : "inline-flex",
              }}
            >
              MEETING
            </Button>
          )}
          {sessionStorage.getItem("it") === "Y" ? (
            <Button
              onClick={(e) => {
                edi();
                e.stopPropagation();
              }}
              variant="text"
              sx={{
                color: "white",
                marginLeft: 5,
                display: windowWidth < 768 ? "none" : "inline-flex",
              }}
            >
              EDI
            </Button>
          ) : (
            ""
          )}
          {/* <Button
            onClick={(e) => {
              reservationgo();
              e.stopPropagation();
            }}
            variant="text"
            sx={{ color: "white", marginLeft: 10 }}
          >
            MEETING
          </Button>
          <Button
            onClick={(e) => {
              samsgo();
              e.stopPropagation();
            }}
            variant="text"
            sx={{ color: "white", marginLeft: 5 }}
          >
            SAMS
          </Button> */}
          <Typography
            variant="text"
            style={{ marginLeft: "auto", marginRight: "30px" }}
          >
            {open === true && windowWidth < 768
              ? ""
              : sessionStorage.getItem("id")}
          </Typography>
          <Button
            onClick={handleLogout}
            variant="text"
            sx={{ color: "white", mr: "15px" }}
          >
            logout
          </Button>
        </Toolbar>
      </AppBar>
      <Drawer variant="permanent" open={open}>
        <DrawerHeader>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List>
          {location.pathname === "/reservation" && (
            <ListItemReservation open={open} />
          )}
          {location.pathname.startsWith("/sams") && (
            <ListItemSams open={open} />
          )}
          {location.pathname.startsWith("/sq") && <ListItemSq open={open} />}
          {location.pathname.startsWith("/edi") && <ListItemIt open={open} />}
          {/* {location.pathname.startsWith("/dpr") && <LISTITEMDPR open={open} />} */}
        </List>
      </Drawer>
    </Box>
  );
}
